export class Contact {
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    phone: string = "";
    subject: string = "";
    message: string = "";
}